import { Injectable } from "@angular/core";
import { RestangularModule, Restangular } from "ngx-restangular";
import { Observable } from "rxjs";
import { HttpClient, HttpHeaders } from "@angular/common/http";


@Injectable()
export class AssessmentMasterService {

  private baseUrl = "/api/v1"; // Replace with your Laravel API URL

  constructor(private restangular: Restangular, private http: HttpClient) {}

  private getHeaders(): HttpHeaders {
    const token =
      localStorage.getItem("access_token") ||
      localStorage.getItem("refresh_token");
    return new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    });
  }

  public createAssessmentMaster() {
    return this.restangular.all("createAssessmentMaster");
  }


  public getAssessmentMaster() {
    return this.restangular.one('getAssessmentMaster');
  }

  public getAssessmentMasterTab1(id) {
    return this.restangular.one('getAssessmentMasterTab1/' + id);
  }

  getAssessmentMasterTab2(id) {
    return this.restangular.one('getAssessmentMasterTab2/' + id);
  }

  updateAssement(id){
    return this.restangular.one('getAssessmentMasterTab2Update/' + id);
  }


  public createNewQuestionHeader() {
    return this.restangular.all('createNewQuestionHeader');
  }

  public updateAssMaster(id) {
    return this.restangular.one('updateAssMaster/' + id);
  }




  // public getQuestionHeaderModal(id) {
  //   return this.restangular.one('getQuestionHeaderModal/' + id);
  // }

  public getQuestionHeaderModal(params) {
    return this.restangular.one('getQuestionHeaderModal').get(params);
  }

  public getFilteredQuesionBank(filter) {
    return this.restangular.all('getFilteredQuesionBank').post(filter);
  }

  // getFilteredQuesionBank(auto_id: number): Observable<any> {
  //   const headers = this.getHeaders();
  //   return this.http.post(`${this.baseUrl}/getFilteredQuesionBank`, { id: auto_id }, {
  //     headers,
  //   });
  // }











  public getQuestionQuestion(id) {
    return this.restangular.one('getQuestionQuestion/' + id);
  }


  public getQuestionMarks(id) {
    return this.restangular.one('getQuestionMarks/' + id);
  }


  public getQuestionCategory(companySystemID) {
    return this.restangular.one('getQuestionCategory/' + companySystemID);
  }
  


  public selectQuestionHeader() {
    return this.restangular.all('selectQuestionHeader');
  }


  public selectQuestionHeaderAutoAdd() {
    return this.restangular.all('selectQuestionHeaderAutoAdd');
  }





  public deleteAssessment(id) {
    return this.restangular.one('deleteAssessment/' + id);
  }



  public deleteAssessmentQuiz(id) {
    return this.restangular.one('deleteAssessmentQuiz/' + id);
  }


  // public getQBCategory() {
  //   return this.restangular.one('getQBCategory');
  // }




  
  public completeAssessment(id) {
    return this.restangular.one("completeAssessment/" + id);
  }
  
  public startMyAss_1(id) {
    return this.restangular.one("startMyAss_1/" + id);
  }

  public startMyAss_2(id, retake, retakeview) {
    return this.restangular.one('startMyAss_2/' + id + '/' + retake + '/' +retakeview);
  }

  public startMyAss_3(id, retake, retakeview) {
    return this.restangular.one('startMyAss_3/' + id + '/' + retake + '/' +retakeview);
  }

  public updateMarks(id) {
    return this.restangular.one("updateMarks/" + id);
  }



  getAssByAssType(id) {
    return this.restangular.one('getAssByAssType/' + id);
  }


  getAssessmentCreateList(id) {
    return this.restangular.one('getAssessmentCreateList/' + id);
  }



  public completeMyAss() {
    return this.restangular.all("completeMyAss");
  }

  public completeWrittenMyAss() {
    return this.restangular.all("completeWrittenMyAss");
  }

  public completeAutoMyAss() {
    return this.restangular.all("completeAutoMyAss");
  }

  public completeAutoMyAssRetake() {
    return this.restangular.all("completeAutoMyAssRetake");
  }



  public assesorMarkingAssessment() {
    return this.restangular.all("assesorMarkingAssessment");
  }


  // getEmployeeAnswers(id) {
  //   return this.restangular.one('getEmployeeAnswers/' + id);
  // }


  getEmployeeAnswers(id: number, assessmentId: number) {
    return this.restangular.one(`getEmployeeAnswers/${id}/${assessmentId}`);
  }
  
  


  getAssessorResults(id) {
    return this.restangular.one('getAssessorResults/' + id);
  }



  printMyAssessmentReport() {
    return this.restangular.all('printMyAssessmentReport');
  }

  generateAssessmentCertificate() {
    return this.restangular.one('generateAssessmentCertificate');
  }


  public assesorRejectRemove() {
    return this.restangular.all("assesorRejectRemove");
  }


  public updateWrittenAnswers() {
    return this.restangular.all("updateWrittenAnswers");
  }





  public retakeMyAss_1(id) {
    return this.restangular.one("retakeMyAss_1/" + id);
  }

  public retakeMyAss_2(id) {
    return this.restangular.one('retakeMyAss_2/' + id);
  }

  public retakeMyAss_3(id) {
    return this.restangular.one('retakeMyAss_3/' + id);
  }






  public completeMyAssRetake() {
    return this.restangular.all("completeMyAssRetake");
  }

  
  getRetakeAssAnswers(id: number, assessmentId: number) {
    return this.restangular.one(`getRetakeAssAnswers/${id}/${assessmentId}`);
  }

  public completeWrittenMyAssRetake() {
    return this.restangular.all("completeWrittenMyAssRetake");
  }


  getAssessmentMasterRetake(id: number, assessmentId: number) {
    return this.restangular.one(`getAssessmentMasterRetake/${id}/${assessmentId}`);
  }


  public assesorMarkingAssessmentRetake() {
    return this.restangular.all("assesorMarkingAssessmentRetake");
  }



  public assesorRejectRemoveRetake() {
    return this.restangular.all("assesorRejectRemoveRetake");
  }


  
  public updateWrittenAnswersRetake() {
    return this.restangular.all("updateWrittenAnswersRetake");
  }

}



// WEBPACK FOOTER //
// /app/src/app/services/assesment-master.service.ts